module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "placeholder": "状态",
      "collapse-tags": false
    },
    model: {
      value: (_vm.orderState),
      callback: function($$v) {
        _vm.orderState = $$v
      },
      expression: "orderState"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "订单号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.List($event)
      }
    },
    model: {
      value: (_vm.filters.OrderNumber),
      callback: function($$v) {
        _vm.$set(_vm.filters, "OrderNumber", $$v)
      },
      expression: "filters.OrderNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "购票人"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.List($event)
      }
    },
    model: {
      value: (_vm.filters.Name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "Name", $$v)
      },
      expression: "filters.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.List
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.ConsumptionBusiness
    }
  }, [_vm._v("扫码核销")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "1702px"
    },
    attrs: {
      "data": _vm.ListData,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderNumber",
      "label": "订单号",
      "width": "250",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderMoney",
      "label": "金额",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CreationTime",
      "label": "下单时间",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ChangeTime",
      "label": "支付时间",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "MemberName",
      "label": "购票人",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Phone",
      "label": "联系电话",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IdCardNumber",
      "label": "身份证号码",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsUse",
      "label": "是否使用",
      "width": "150",
      "formatter": _vm.formatIsUse,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "UseTime",
      "label": "使用时间",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "State",
      "label": "状态",
      "width": "120",
      "sortable": "",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.OrderState == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "medium"
          }
        }, [_vm._v("未支付")]) : _vm._e(), _vm._v(" "), (scope.row.OrderState == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "medium"
          }
        }, [_vm._v("已支付")]) : _vm._e(), _vm._v(" "), (scope.row.OrderState == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "medium"
          }
        }, [_vm._v("已取消")]) : _vm._e(), _vm._v(" "), (scope.row.OrderState == 3) ? _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "medium"
          }
        }, [_vm._v("手动核销")]) : _vm._e(), _vm._v(" "), (scope.row.OrderState == 4) ? _c('el-tag', {
          attrs: {
            "type": "primary",
            "size": "medium"
          }
        }, [_vm._v("扫码核销")]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.OrderState == 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              _vm.verification(scope.row)
            }
          }
        }, [_vm._v("核销")]) : _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning",
            "disabled": true
          },
          on: {
            "click": function($event) {
              _vm.verification(scope.row)
            }
          }
        }, [_vm._v("核销")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "width": "100%",
      "margin": "0 auto",
      "padding-top": "0px",
      "padding-right": "0.25em",
      "padding-bottom": "2ex",
      "padding-left": "0px"
    },
    attrs: {
      "title": "请检查扫码枪是否连接",
      "custom-class": "",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeDialog
    },
    model: {
      value: (_vm.Machine),
      callback: function($$v) {
        _vm.Machine = $$v
      },
      expression: "Machine"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 25
    }
  }, [_c('el-card', {
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "siteInput",
    staticClass: "input",
    attrs: {
      "clearable": "",
      "autofocus": _vm.focusvalue,
      "placeholder": "请扫码"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.BusinessHandle($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.BusinessHandle
    }
  }, [_vm._v("确认扫码")])], 1)], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2504d778"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/TicketManagement/TicketOrder.vue
// module id = 1335
// module chunks = 1